export enum PendingBrandingProperties {
  ProfileImage = 'profileImage',
  BannerImage = 'bannerImage',
  WatermarkImage = 'watermarkImage',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
  Profile = 'profile',
  Approved = 'approved',
  Status = 'status',
  Zone = 'zone',
  ReleaseActions = 'releaseActions',
  AssignedPlayer = 'assignedPlayer',
}
export enum PendingBrandingMetaProperties {
  ProfileId = 'Profile-id',
  ProfileVersion = 'Profile-version',
  ZoneId = 'Zone-id',
  ZoneVersion = 'Zone-version',
  ReleaseActionsId = 'ReleaseActions-id',
  ReleaseActionsVersion = 'ReleaseActions-version',
  AssignedPlayerId = 'AssignedPlayer-id',
  AssignedPlayerVersion = 'AssignedPlayer-version',
}
